const staticText = {
  apply: 'Apply',
  resetAll: 'Reset',
  logDaysAllowance: logDays => `Your current plan provides access to the most recent ${logDays} day${logDays > 1 ? 's' : ''} of Connect data.`,
  maxLogDays: logDays => `Connect data can be viewed up to the past ${logDays} days.`,
  featureGated: {
    upgrade: '|+|Upgrade@@/team/billing|+| to access more.',
    contactOwnersToUpgrade: 'To access more, contact your team owner to upgrade your plan.',
  },
  allDates: 'All dates',
};

export const inputConfig = {
  inputs: [
    {
      filterKey: 'vin',
      label: 'Single Select VIN',
      id: 'filter-vin',
      placeholder: 'Enter VIN',
    },
    {
      filterKey: 'sessionId',
      label: 'Session ID',
      id: 'filter-session-id',
      placeholder: 'Enter Session ID',
    },
    {
      filterKey: 'customerVehicleOwnerId',
      label: 'User',
      id: 'filter-user',
      placeholder: 'Enter User ID',
    },
  ],
  dateRange: {
    label: 'Date range',
    id: 'filter-date-range',
  },
};

export default staticText;
